<script setup lang="ts">
/**
 * Light/dark toggle in the template's switch shape: a lilac track with a dark
 * dot that slides across, the same control the pricing page uses for
 * monthly/yearly.
 */
const colorMode = useColorMode();
const { t } = useI18n();

const isDark = computed(() => colorMode.value === 'dark');

function toggleTheme() {
  colorMode.preference = isDark.value ? 'light' : 'dark';
}
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="isDark"
    :aria-label="t('sofax.nav.themeToggle')"
    :title="t('sofax.nav.themeToggle')"
    class="group inline-flex items-center gap-3 focus:outline-none"
    @click="toggleTheme"
  >
    <i class="bi bi-sun-fill text-base text-ink transition-colors dark:text-gray-500" aria-hidden="true" />
    <span
      class="relative inline-block h-[1.875rem] w-[3.5rem] shrink-0 rounded-full bg-lilac transition-colors duration-300 group-focus-visible:ring-2 group-focus-visible:ring-accent group-focus-visible:ring-offset-2"
    >
      <span
        class="absolute left-[4px] top-1/2 flex size-[1.375rem] -translate-y-1/2 items-center justify-center rounded-full bg-ink shadow transition-transform duration-300"
        :class="isDark ? 'translate-x-[1.625rem]' : 'translate-x-0'"
      />
    </span>
    <i class="bi bi-moon-stars-fill text-base text-gray-400 transition-colors dark:text-white" aria-hidden="true" />
  </button>
</template>
